import React from 'react';
import './SkillBadge.scss';

const SkillBadge = ({ skill }) => {
	return <span className="skill-badge">{skill}</span>;
};

export default SkillBadge;
